import React from "react";
import DropdownSelect from "../../DropdownSelect";
import infoIcon from "../../../../assets/images/about_icon.svg";

/**
 * Dropdown Filters Component
 * Contains Station, Department, Classification, and Duty Assignment dropdowns
 */
const DropdownFilters = ({
    // Station props
    stationOptions,
    selectedStation,
    onSelectStation,
    isStationError,
    
    // Department props
    departmentOptions,
    selectedDepartment,
    onSelectDepartment,
    
    // Classification props
    classificationOptions,
    selectedClassification,
    onSelectClassification,
    
    // Duty Assignment props
    dutyAssigOptions,
    selectedDutyAssig,
    onSelectDutyAssig,
    
    // Common props
    isCheckedApplyAll,
    onApplyAllChange,
    showCDAError
}) => {
    return (
        <>
            {/* Station & Department Dropdowns */}
            <div className="dropdown-form" style={{ display: "flex", flexWrap: "wrap" }}>
                <div className="flex-column-wrap-gap">
                    <DropdownSelect
                        title={"Station"}
                        options={stationOptions}
                        selectedOption={selectedStation}
                        setSelectedOption={onSelectStation}
                        isRequired={true}
                        isEnabled={!isStationError}
                        error={(showCDAError && !selectedStation) || isStationError}
                    />
                    {isStationError && (
                        <p className="error" style={{ color: "red" }}>
                            *No stations available. Please try again later.
                        </p>
                    )}
                </div>
                <DropdownSelect
                    title={"Department"}
                    options={departmentOptions}
                    selectedOption={selectedDepartment}
                    setSelectedOption={onSelectDepartment}
                    isRequired={true}
                    isEnabled={selectedStation.length > 0}
                    error={showCDAError && !selectedDepartment}
                />
            </div>

            {/* Classification & Duty Assignment Dropdowns */}
            <div className="dropdown-form" style={{ display: "flex", flexWrap: "wrap", marginTop: 30 }}>
                <DropdownSelect
                    title={"Duty Assignment"}
                    options={dutyAssigOptions}
                    selectedOption={selectedDutyAssig}
                    setSelectedOption={onSelectDutyAssig}
                    isRequired={true}
                    isEnabled={isCheckedApplyAll}
                    error={isCheckedApplyAll && !selectedDutyAssig && showCDAError}
                />
                <DropdownSelect
                    title={"Classification"}
                    options={classificationOptions}
                    selectedOption={selectedClassification}
                    setSelectedOption={onSelectClassification}
                    isRequired={true}
                    isEnabled={isCheckedApplyAll}
                    error={isCheckedApplyAll && !selectedClassification && showCDAError}
                />
            </div>

            {/* Apply All Checkbox */}
            <div className="flex-nowrap-center-ml" onClick={onApplyAllChange}>
                <input 
                    onChange={onApplyAllChange} 
                    type="checkbox" 
                    checked={isCheckedApplyAll} 
                />
                <p 
                    className="note" 
                    style={{ 
                        margin: 0, 
                        marginLeft: 10, 
                        color: !isCheckedApplyAll && "#0000002d" 
                    }}
                >
                    Apply Classification and Duty Assignment to all offers.
                </p>
            </div>
            {!isCheckedApplyAll && (
                <div style={{ display: "flex", alignItems: 'center' }}>
                    <img src={infoIcon} alt="Info" />
                    <p className="note" style={{ margin: 0 }}>
                        Classification and Duty Assignment are required and will need to be selected within each offer.
                    </p>
                </div>
            )}
        </>
    );
};

export default DropdownFilters;
